// extracted by mini-css-extract-plugin
module.exports = {"adminContainer":"admin-layout_adminContainer__2_mhr","sidebarContainer":"admin-layout_sidebarContainer__79_5v","adminContent":"admin-layout_adminContent__1FDCb"};